import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Rocket, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export function FinalCTASection() {
  return (
    <section className="relative py-20 sm:py-28 bg-gradient-to-b from-muted/30 to-background overflow-hidden">
      {/* Background effects */}
      <div className="absolute inset-0">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gradient-radial from-primary/10 to-transparent rounded-full" />
        <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary/30 to-transparent" />
      </div>

      <div className="container relative mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-4xl mx-auto text-center"
        >
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold tracking-wide text-foreground mb-6 leading-tight">
            OU VOCÊ CONTINUA{" "}
            <span className="text-muted-foreground">NO IMPROVISO...</span>
            <br />
            <span className="text-primary">
              OU COMEÇA A TRATAR SEU FREELANCING
            </span>
            <br />
            <span className="text-primary">COMO UM NEGÓCIO.</span>
          </h2>

          <p className="text-xl text-muted-foreground mb-10 max-w-2xl mx-auto">
            Você já tem o talento. Só falta o sistema certo para transformar isso em{" "}
            <span className="text-foreground font-medium">resultados previsíveis</span>.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
            <Link to="/signup">
              <Button
                size="lg"
                className="h-16 px-10 text-lg bg-primary hover:bg-primary/90 text-primary-foreground shadow-lg shadow-primary/20 gap-3 group"
              >
                <Rocket className="h-6 w-6 group-hover:animate-pulse" />
                Quero organizar minha renda agora
                <ArrowRight className="h-5 w-5 group-hover:translate-x-1 transition-transform" />
              </Button>
            </Link>
          </div>

          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 }}
            className="text-muted-foreground text-sm flex items-center justify-center gap-3 flex-wrap"
          >
            <span className="flex items-center gap-1.5">
              <span className="w-1.5 h-1.5 rounded-full bg-primary" />
              Comece hoje
            </span>
            <span className="flex items-center gap-1.5">
              <span className="w-1.5 h-1.5 rounded-full bg-primary" />
              Veja clareza ainda este mês
            </span>
            <span className="flex items-center gap-1.5">
              <span className="w-1.5 h-1.5 rounded-full bg-primary" />
              7 dias grátis
            </span>
          </motion.p>
        </motion.div>
      </div>
    </section>
  );
}
